import React, { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSnackbar from "components/SoftSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import refreshBtn from "../../assets/images/refresh_btn.png";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { Card } from "react-bootstrap";
import Select from "react-select";
import {
  TextField,
  Box,
  Grid as MuiGrid,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { Modal } from "react-bootstrap";
import { CSVLink, CSVDownload } from "react-csv";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import moment from "moment/moment";
import noDataImg from "../../../src/assets/images/browser.png";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import FadeLoader from "react-spinners/FadeLoader";
import DOMPurify from "dompurify";
import refresh from "../../assets/images/refresh.png";
import A from "../../assets/images/briefcase.png";
import B from "../../assets/images/user.png";
import C from "../../assets/images/calendar.png";
import D from "../../assets/images/Group 27463.png";
import v1 from "../../assets/images/Vector (1).png";
import v2 from "../../assets/images/Vector.png";
import styled from "@emotion/styled";
import { match } from "stylis";
import { Table } from "antd";
import { colGuidelines, GuideData } from "./CandidatesList";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ST1 = styled(Typography)({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#000000",
});

const ST2 = styled(Typography)({
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#000000",
});

const ST3 = styled(Typography)({
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Poppins",
  color: "#3B5092",
});

const copy = require("clipboard-copy");
const JobRequestPage = () => {
  const navigate = useNavigate();
  const isInternshipPage =
    window.location.pathname.split("/")[window.location.pathname.split("/").length - 1] ===
    "internship-request";
  // console.log("location:::", isInternshipPage);
  const override = {
    display: "block",
    margin: "100px auto ",
    borderColor: "red",
  };
  const matchsm = useMediaQuery("(max-width:768.5px)");
  const cpId = sessionStorage.getItem("register_id");
  const [instructionModal, setInstructionModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [reqList, setReqList] = useState([]);
  const [acceptList, setAcceptList] = useState([]);
  const [declineList, setDeclineList] = useState([]);
  const [uploadedList, setUploadedList] = useState([]);
  const [uploadedOption, setUploadOption] = useState(false);
  const [CSVFile, setCSVFile] = useState("");
  const [tableshow, setTableshow] = useState(0);
  const [viewIndex, setViewIndex] = useState("");
  const [uploadModal, setUploadModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadingModal, setUploadingModal] = useState(false);
  const [objectOfLinks, setObjectOfLinks] = useState({
    formLink: "",
    qrLink: "",
    jobId: "",
    orgid: "",
  });
  var fileSaver = require("file-saver");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [copiedLink, setCopiedLink] = useState("");

  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };

  const viewList = [
    {
      label: "Requests",
      value: "Requests",
    },
    {
      label: "Declined",
      value: "Declined",
    },
    {
      label: "Archieved",
      value: "Archieved",
    },
  ];
  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      width: !matchsm ? "200px" : "100%",
      height: "41px",
      width: "200px",
      fontFamily: "Poppins",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };
  const toggleSnackbar = () => setShowSnackbar(!showSnackbar);
  const handleAccept = async (data) => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/modify/job/status`,
        {
          jobid: data.jobpost_id,
          cp_id: data.registration,
          orgid: data.org_id,
          request_status: "accepted",
          candidate_count: data.candidate_count,
          counter: data.counter,
        }
      )
      .then((res) => {
        AcceptFunc(res.data);
      })
      .catch((err) => {
        console.log("err:", err.response);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  console.log(reqList, "aaa");

  const handleDecline = async (data) => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/modify/job/status`,
        {
          jobid: data.jobpost_id,
          cp_id: data.registration,
          request_status: "declined",
          candidate_count: data.candidate_count,
          counter: data.counter,
        }
      )
      .then((res) => {
        // AcceptFunc();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Request Declined Successfully",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => RequestedList());
      })
      .catch((err) => {
        console.log("err:", err.response);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  const AcceptFunc = (data) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-success",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Work Order Generated",
        text: `Your work order (id: ${data.work_order_id}) for ${data.job_data.applicantct} candidates of ${data.job_data.designation} for ${data.job_data.org_name} has been generated.`,
        icon: "success",
        // showCancelButton: true,
        // confirmButtonColor: "#3B5092",
        // cancelButtonColor: "#3B5092",
        // confirmButtonText: "Download",
        // cancelButtonText: "Proceed",
        showCancelButton: false,
        confirmButtonText: "Proceed",
      })
      .then((result) => {
        // if (result.isConfirmed) {
        //   Swal.fire("Downloaded!", "Your work order has been downloaded.", "success").then(() =>
        //     RequestedList()
        //   );
        // } else {
        //   setStep2(true);
        //   setStep1(false);
        //   // RequestedList();
        //   AcceptedList();
        // }
        if (result.isConfirmed) {
          RequestedList();
        }
      });
  };
  const RequestedList = async () => {
    setIsLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/request/job`, {
        params: {
          cp_id: cpId,
          request_status: "requested",
          job_type: isInternshipPage ? "Internship" : "",
        },
      })
      .then((res) => {
        console.log("req:", res.data["cp_data"]);
        setReqList(res.data["cp_data"]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("req err:", err.response);
      });
  };
  const AcceptedList = async () => {
    setIsLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/request/job`, {
        params: {
          cp_id: cpId,
          request_status: "accepted",
          job_type: isInternshipPage ? "Internship" : "",
        },
      })
      .then((res) => {
        console.log("accept:", res.data["cp_data"]);
        setAcceptList(res.data["cp_data"]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("accept err:", err.response);
      });
  };
  const UploadedListFunc = async () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("cp_id", cpId);
    formData.append("job_type", isInternshipPage ? "Internship" : "");
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/jobs/inactive`,
        formData
      )
      .then((res) => {
        console.log("accept:", res.data["inactive_data"]);
        setUploadedList(res.data["inactive_data"]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("accept err:", err.response);
      });
  };
  const DeclinedList = async () => {
    setIsLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/request/job`, {
        params: {
          cp_id: cpId,
          request_status: "declined",
          job_type: isInternshipPage ? "Internship" : "",
        },
      })
      .then((res) => {
        console.log("decline:", res.data["cp_data"]);
        setDeclineList(res.data["cp_data"]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("decline err:", err.response);
      });
  };
  const bulkUploadfunc = () => {
    setLoading(true);
    setUploadingModal(true);
    // Swal.fire({
    //   //icon: "success",
    //   title: "Uploading",
    //   text: "File Upload is in progress",
    //   showConfirmButton: false,
    //   timer: 3000,
    // });
    let formData = new FormData();
    formData.append("jobseeker_file", CSVFile);
    formData.append("cpid", cpId);
    formData.append("jobid", objectOfLinks.jobId);
    formData.append("orgid", objectOfLinks.orgid);
    formData.append("job_type", isInternshipPage ? "Internship" : "");
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/bulkupload`,
        formData
      )
      .then((res) => {
        setLoading(false);
        setUploadingModal(false);
        if (res.status === 201) {
          /*
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "File Uploaded successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          */
          Swal.fire({
            icon: "success",
            // title: "Success",
            // text: "File Uploaded successfully",
            title: "File Uploaded Successfully",
            html:
              "Successfully Uploaded: " +
              `${res.data["Success"]}` +
              "<br/>" +
              "Failed In Uploading: " +
              `${res.data["On Hold"]}` +
              "<br/>" +
              "Data Already Existing With Us: " +
              `${res.data["Duplicates"]}`,
            showConfirmButton: res?.data?.link !== "" ? true : false,
            confirmButtonText: "Data Quality Issue",
            // timer: 3000,
          }).then((result) => {
            if (result.isConfirmed) {
              if (res?.data?.link !== "") {
                //var blob = new Blob([res.data.link], { type: ".csv" });
                //fileSaver.saveAs(blob, "download.csv");
                const link = document.createElement("a");
                link.href = res?.data?.link;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                console.log("error");
              }
            }
          });
          // setactionModal2(false);
          setUploadModal(false);
          setUploadOption(false);
          setShowSnackbar(false);
          AcceptedList();
          UploadedListFunc();
          // setUploadModal(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: err.response.data["Developer Message"]
            ? err.response.data["Developer Message"]
            : "Oops...",
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  useEffect(() => {
    RequestedList();
    UploadedListFunc();
    setTableshow(0);
    // step1 === true ||
  }, [isInternshipPage]);
  /*
  useEffect(() => {
    AcceptedList();
  }, [step2 === true]);
  */
  /*
  useEffect(() => {
    DeclinedList();
  }, [step3 === true]);
  */

  return (
    <>
      <DashboardLayout>
        <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <Box sx={{ pb: 1 }}>
            <Select
              options={viewList}
              value={
                step1
                  ? {
                      label: "Requests",
                      value: "Requests",
                    }
                  : step2
                  ? {
                      label: "Archieved",
                      value: "Archieved",
                    }
                  : {
                      label: "Declined",
                      value: "Declined",
                    }
              }
              styles={stylesDD}
              onChange={(e) => {
                {
                  e.value === "Requests"
                    ? (setStep1(true),
                      setStep2(false),
                      setStep3(false),
                      setTableshow(0),
                      RequestedList())
                    : e.value === "Archieved"
                    ? (setStep1(false), setStep2(true), setStep3(false), UploadedListFunc())
                    : (setStep1(false), setStep2(false), setStep3(true), DeclinedList());
                }
              }}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", pb: 1 }}>
            {step1 && (
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  pr: 2,
                }}
              >
                <SoftBox
                  sx={{
                    border: "1px solid #000",
                    borderRadius: "5px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                    width: "100px",
                    height: "45px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    p: 1,
                    textAlign: "center",
                    backgroundColor: tableshow === 0 ? "#3B5092" : "#fff",
                  }}
                  onClick={() => {
                    setTableshow(0);
                    RequestedList();
                  }}
                >
                  <SoftTypography
                    sx={
                      tableshow === 0
                        ? {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // color: "#1B59F8",
                            color: "#fff",
                            fontSize: "16px",
                          }
                        : {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // color: "#000",
                            color: "#3B5092",
                            fontSize: "16px",
                          }
                    }
                  >
                    New
                  </SoftTypography>
                </SoftBox>

                {/*
              <SoftBox
                sx={{
                  borderTop: "1px solid #000",
                  borderBottom: "1px solid #000",
                  width: "100px",
                  height: "45px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  p: 1,
                  textAlign: "center",
                  backgroundColor: tableshow === 1 ? "#3B5092" : "#fff",
                }}
                onClick={() => {
                  setTableshow(1);
                  AcceptedList();
                }}
              >
                <SoftTypography
                  sx={
                    tableshow === 1
                      ? {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // color: "#1B59F8",
                        color: "#fff",
                        fontSize: "16px",
                      }
                      : {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#3B5092",
                        fontSize: "16px",
                      }
                  }
                >
                  Active
                </SoftTypography>
              </SoftBox>
              */}

                <SoftBox
                  sx={{
                    border: "1px solid #000",
                    borderRadius: "5px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    width: "100px",
                    height: "45px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    p: 1,
                    textAlign: "center",
                    backgroundColor: tableshow === 1 ? "#3B5092" : "#fff",
                  }}
                  onClick={() => {
                    setTableshow(1);
                    AcceptedList();
                  }}
                >
                  <SoftTypography
                    sx={
                      tableshow === 1
                        ? {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // color: "#1B59F8",
                            color: "#fff",
                            fontSize: "16px",
                          }
                        : {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#3B5092",
                            fontSize: "16px",
                          }
                    }
                  >
                    Active
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            )}

            <SoftBox
              sx={{
                height: "34px",
                backgroundColor: "#FFF",
                borderRadius: "2px",
                cursor: "pointer",
                p: 1,
              }}
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="40px"
              onClick={() =>
                step3
                  ? (DeclinedList(), setViewIndex(""), setShowSnackbar(false))
                  : step1 && tableshow === 0
                  ? (RequestedList(), setViewIndex(""), setShowSnackbar(false))
                  : step1 && tableshow === 1
                  ? (AcceptedList(), setViewIndex(""), setShowSnackbar(false))
                  : (UploadedListFunc(), setViewIndex(""), setShowSnackbar(false))
              }
            >
              <SoftBox>
                <img src={refreshBtn} />
              </SoftBox>
            </SoftBox>
          </Box>
        </Box>

        <SoftBox display="flex" flexDirection="column">
          {step1 && (
            <SoftBox display="flex" flexDirection="column">
              {tableshow === 0 && step1 ? (
                <>
                  {!isLoading ? (
                    <>
                      <SoftBox display="flex" flexDirection="column">
                        <ST3 variant="body1" p={2}>
                          New Requests
                        </ST3>
                      </SoftBox>

                      {reqList.length === 0 ? (
                        <>
                          <SoftBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            mt="50px"
                          >
                            <img src={noDataImg} width="100px" height="100px" />
                            <ST1 sx={{ mt: 1 }}>No new job requests</ST1>
                          </SoftBox>
                        </>
                      ) : (
                        <>
                          <Box>
                            <MuiGrid container spacing={3} sx={{ p: 2 }}>
                              {reqList?.map((ele, id) => (
                                <MuiGrid item xs={12} key={id}>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      background: "#FFFFFF",
                                      border: "1px solid #C6C6C6",
                                      borderRadius: "8px",
                                      boxShadow: 1,
                                    }}
                                  >
                                    <MuiGrid container>
                                      <MuiGrid item lg={3.5} md={6} sm={12} xs={12}>
                                        <Box sx={{ p: 2 }}>
                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            <span style={{ color: "#6C6C6C" }}>Organization:</span>{" "}
                                            {ele.org_name}
                                          </ST1>

                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            <span style={{ color: "#6C6C6C" }}>Job Profile:</span>{" "}
                                            {ele.job_title}
                                          </ST1>

                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            {moment(ele.createddt).format("LLLL")}
                                          </ST1>
                                        </Box>
                                      </MuiGrid>

                                      <MuiGrid item lg={5} md={6} sm={12} xs={12}>
                                        <Box sx={{ p: 2 }}>
                                          <Box sx={{ mb: 3 }}>
                                            <ST1 variant="body2" sx={{ p: 0.25 }}>
                                              <span style={{ color: "#6C6C6C" }}>
                                                Cost/Candidate:
                                              </span>{" "}
                                              ₹{" "}
                                              {ele?.amount_per_candidate
                                                ? parseInt(ele?.amount_per_candidate)
                                                : ""}
                                            </ST1>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: !matchsm ? "row" : "column",
                                              flexWrap: "nowrap",
                                            }}
                                          >
                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={D} alt="" height={"18px"} />

                                              <ST2 variant="caption">&nbsp;{ele.district}</ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={A} alt="" height={"18px"} />

                                              <ST2 variant="caption">&nbsp;{ele.job_type}</ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={C} alt="" height={"18px"} />

                                              <ST2 variant="caption">
                                                &nbsp;
                                                {moment(ele.jobpostdt).startOf("hour").fromNow()}
                                              </ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={B} alt="" height={"18px"} />

                                              <ST2 variant="caption">
                                                &nbsp;
                                                {ele.gender && ele.gender !== ""
                                                  ? ele.gender
                                                  : "Any"}
                                              </ST2>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </MuiGrid>

                                      <MuiGrid item lg={3.5} md={12} sm={12} xs={12}>
                                        <Box
                                          sx={{
                                            p: 1,
                                            display: "flex",
                                            flexDirection: !matchsm ? "row" : "column",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            height: "100%",
                                            // gap: "10px",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              width: !matchsm ? "none" : "100%",
                                              marginRight: !matchsm ? "0px" : "10px",
                                            }}
                                          >
                                            <Button
                                              onClick={() =>
                                                // acceptSwal(true),
                                                // AcceptFunc()
                                                handleAccept(ele)
                                              }
                                              sx={{
                                                m: 1,
                                                p: 2,
                                                width: !matchsm ? "110px" : "100%",
                                                height: "34px",
                                                background: "#3B5092",
                                                textTransform: "none",
                                                "&:hover": {
                                                  background: "#3B5092",
                                                },
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  fontSize: "14px",
                                                  fontWeight: 400,
                                                  lineHeight: "26px",
                                                  fontFamily: "Poppins",
                                                  color: "#FFFFFF",
                                                }}
                                              >
                                                Accept
                                              </Typography>
                                            </Button>
                                          </Box>

                                          <Box
                                            sx={{
                                              width: !matchsm ? "none" : "100%",
                                              marginRight: !matchsm ? "0px" : "10px",
                                            }}
                                          >
                                            <Button
                                              onClick={() => handleDecline(ele)}
                                              sx={{
                                                m: 1,
                                                p: 2,
                                                width: !matchsm ? "110px" : "100%",
                                                height: "34px",
                                                border: "1px solid #3B5092",
                                                background: "#FFFFFF",
                                                textTransform: "none",
                                                "&:hover": {
                                                  border: "1px solid #3B5092",
                                                  background: "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  fontSize: "14px",
                                                  fontWeight: 400,
                                                  lineHeight: "26px",
                                                  fontFamily: "Poppins",
                                                  color: "#3B5092",
                                                }}
                                              >
                                                Decline
                                              </Typography>
                                            </Button>
                                          </Box>
                                        </Box>
                                      </MuiGrid>
                                    </MuiGrid>

                                    <Box>
                                      {viewIndex === id && (
                                        <Box sx={{ width: "100%", p: 2 }}>
                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Candidates Requirement:
                                                </span>{" "}
                                                {ele.applicantct ? ele.applicantct : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                            {ele.applicantct ? ele.applicantct : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ width: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Assigned Candidates Requirement:
                                                </span>{" "}
                                                {ele.candidate_required
                                                  ? ele.candidate_required
                                                  : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                            {ele.candidate_required ? ele.candidate_required : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Education:</span>{" "}
                                                {ele.qualification ? ele.qualification : "NA"}
                                              </ST1>
                                            </Box>

                                            {/*<ST1 variant="body2">
                                             {ele.qualification ? ele.qualification : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Role:</span>{" "}
                                                {ele.designation ? ele.designation : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                            {ele.designation ? ele.designation : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Key Skills:
                                                </span>{" "}
                                                {ele.skills ? ele.skills : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                            {ele.skills ? ele.skills : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Salary:</span>{" "}
                                                {ele.salary ? `₹ ${ele.salary}` : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                            {ele.salary ? `₹ ${ele.salary}` : "NA"}
                                          </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Job Description:
                                                </span>{" "}
                                                <Typography
                                                  variant="body2"
                                                  sx={{ color: "#000000" }}
                                                  dangerouslySetInnerHTML={createMarkup(
                                                    ele.jobdesc ? ele.jobdesc : "<p>NA</p>"
                                                  )}
                                                />
                                              </ST1>
                                            </Box>

                                            {/* <Typography
                                            variant="body2"
                                            sx={{ color: "#000000" }}
                                            dangerouslySetInnerHTML={createMarkup(
                                              ele.jobdesc ? ele.jobdesc : "<p>NA</p>"
                                            )}
                                          /> */}
                                          </Box>
                                        </Box>
                                      )}
                                    </Box>
                                    {viewIndex === "" ? (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex(id)}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          More details <img src={v1} alt="" />
                                        </Typography>
                                      </Box>
                                    ) : viewIndex === id ? (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex("")}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          Hide details <img src={v2} alt="" />
                                        </Typography>
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex(id)}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          More details <img src={v1} alt="" />
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </MuiGrid>
                              ))}
                            </MuiGrid>
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        mt="50px"
                      >
                        <FadeLoader
                          color="#3B5092"
                          height={12}
                          width={5}
                          radius={2}
                          // margin={2}
                          cssOverride={override}
                        />
                      </SoftBox>
                    </>
                  )}
                </>
              ) : null}

              {tableshow === 1 && step1 ? (
                <>
                  {!isLoading ? (
                    <>
                      <SoftBox display="flex" flexDirection="column">
                        <ST3 variant="body1" p={2}>
                          Active Requests
                        </ST3>
                      </SoftBox>

                      {acceptList.length !== 0 ? (
                        <>
                          <Box>
                            <MuiGrid container spacing={3} sx={{ p: 2 }}>
                              {acceptList?.map((ele, id) => (
                                <MuiGrid item xs={12} key={id}>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      background: "#FFFFFF",
                                      border: "1px solid #C6C6C6",
                                      borderRadius: "8px",
                                      boxShadow: 1,
                                    }}
                                  >
                                    <MuiGrid container>
                                      <MuiGrid item lg={4} md={6} sm={12} xs={12}>
                                        <Box sx={{ p: 2 }}>
                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            <span style={{ color: "#6C6C6C" }}>Organization:</span>{" "}
                                            {ele.org_name}
                                          </ST1>

                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            <span style={{ color: "#6C6C6C" }}>Job Profile:</span>{" "}
                                            {ele.job_title}
                                          </ST1>

                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            {ele.work_order_id
                                              ? ele.work_order_id?.slice(0, 16)
                                              : "-"}
                                          </ST1>

                                          <ST1 variant="body2" sx={{ p: 0.25 }}>
                                            {/* {moment(ele.createddt).format("LLLL")} */}
                                            {moment(ele.accepteddt).format("LLLL")}
                                          </ST1>
                                        </Box>
                                      </MuiGrid>

                                      <MuiGrid item lg={4} md={6} sm={12} xs={12}>
                                        <Box sx={{ p: 2 }}>
                                          <Box sx={{ p: 0.25, mb: 3 }}>
                                            <ST1 variant="body2" sx={{ p: 0.25 }}>
                                              <span style={{ color: "#6C6C6C" }}>
                                                Cost/Candidate:
                                              </span>{" "}
                                              ₹{" "}
                                              {ele?.amount_per_candidate
                                                ? parseInt(ele?.amount_per_candidate)
                                                : ""}
                                            </ST1>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              flexWrap: "wrap",
                                              maxWidth: "400px",
                                            }}
                                          >
                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={D} alt="" height={"18px"} />

                                              <ST2 variant="caption">&nbsp;{ele.district}</ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={A} alt="" height={"18px"} />

                                              <ST2 variant="caption">&nbsp;{ele.job_type}</ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={C} alt="" height={"18px"} />

                                              <ST2 variant="caption">
                                                &nbsp;
                                                {moment(ele.jobpostdt).startOf("hour").fromNow()}
                                              </ST2>
                                            </Box>

                                            <Box sx={{ display: "flex", p: 1, minWidth: "50px" }}>
                                              <img src={B} alt="" height={"18px"} />

                                              <ST2 variant="caption">
                                                &nbsp;
                                                {ele.gender && ele.gender !== ""
                                                  ? ele.gender
                                                  : "Any"}
                                              </ST2>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </MuiGrid>

                                      <MuiGrid item lg={4} md={12} sm={12} xs={12}>
                                        <Box
                                          sx={{
                                            p: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            height: "100%",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              width: !matchsm ? "none" : "100%",
                                              marginRight: !matchsm ? "0px" : "10px",
                                            }}
                                          >
                                            <Button
                                              sx={{
                                                m: 1,
                                                p: 2,
                                                minWidth: !matchsm ? "200px" : "100%",
                                                height: "34px",
                                                background: "#DFE3E8",
                                                textTransform: "none",
                                                "&:hover": {
                                                  background: "#DFE3E8",
                                                  cursor: "none",
                                                },
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  fontSize: "14px",
                                                  fontWeight: 400,
                                                  lineHeight: "26px",
                                                  fontFamily: "Poppins",
                                                  color: "#3B5092",
                                                }}
                                              >
                                                {ele.number_of_applicants} Candidates
                                              </Typography>
                                            </Button>
                                          </Box>

                                          <Box
                                            sx={{
                                              width: !matchsm ? "none" : "100%",
                                              marginRight: !matchsm ? "0px" : "10px",
                                            }}
                                          >
                                            <Button
                                              onClick={() => (
                                                setUploadModal(true),
                                                setObjectOfLinks(() => ({
                                                  ...objectOfLinks,
                                                  formLink: ele.form_link,
                                                  qrLink: ele.qr_code,
                                                  jobId: ele.jobid,
                                                  orgid: ele.orgid,
                                                }))
                                              )}
                                              sx={{
                                                m: 1,
                                                p: 2,
                                                width: !matchsm ? "50px" : "100%",
                                                height: "34px",
                                                background: "#3B5092",
                                                textTransform: "none",
                                                "&:hover": {
                                                  background: "#3B5092",
                                                },
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                              >
                                                <path
                                                  d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
                                                  stroke="white"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                                <path
                                                  d="M15 6L10 1L5 6"
                                                  stroke="white"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                                <path
                                                  d="M10 1V13"
                                                  stroke="white"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            </Button>
                                          </Box>
                                        </Box>
                                      </MuiGrid>

                                      {/* <Box
                                    sx={{
                                      width: "100%",
                                      height: "24px",
                                      background: "#C6C6C6",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      onClick={() => setViewIndex(id)}
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        lineHeight: "26px",
                                        fontFamily: "Poppins",
                                        color: "#3B5092",
                                        "&:hover": {
                                          cursor: "pointer",
                                        },
                                      }}
                                    >
                                      More details
                                    </Typography>
                                  </Box> */}
                                    </MuiGrid>

                                    <Box>
                                      {viewIndex === id && (
                                        <Box sx={{ width: "100%", p: 2 }}>
                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Candidates Requirement:
                                                </span>{" "}
                                                {ele.applicantct ? ele.applicantct : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.applicantct ? ele.applicantct : "NA"}
                                            </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ width: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Assigned Candidates Requirement:
                                                </span>{" "}
                                                {ele.candidate_required
                                                  ? ele.candidate_required
                                                  : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.candidate_required
                                                ? ele.candidate_required
                                                : "NA"}
                                            </ST1> */}
                                          </Box>
                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ width: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Job Post Created on:
                                                </span>{" "}
                                                {ele.createddt
                                                  ? moment(ele.createddt).format("LLLL")
                                                  : "NA"}
                                              </ST1>
                                            </Box>
                                          </Box>
                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Education:</span>{" "}
                                                {ele.qualification ? ele.qualification : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.qualification ? ele.qualification : "NA"}
                                            </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Role:</span>{" "}
                                                {ele.designation ? ele.designation : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.designation ? ele.designation : "NA"}
                                            </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Key Skills:
                                                </span>{" "}
                                                {ele.skills ? ele.skills : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.skills ? ele.skills : "NA"}
                                            </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>Salary:</span>{" "}
                                                {ele.salary ? `₹ ${ele.salary}` : "NA"}
                                              </ST1>
                                            </Box>

                                            {/* <ST1 variant="body2">
                                              {ele.salary ? `₹ ${ele.salary}` : "NA"}
                                            </ST1> */}
                                          </Box>

                                          <Box sx={{ display: "flex", mb: 0.75 }}>
                                            <Box sx={{ minWidth: "220px" }}>
                                              <ST1
                                                variant="body2"
                                                sx={{ p: 0.25 }}
                                                // style={{ color: "#6C6C6C", padding: "2px" }}
                                              >
                                                <span style={{ color: "#6C6C6C" }}>
                                                  Job Description:
                                                </span>{" "}
                                                <Typography
                                                  variant="body2"
                                                  sx={{ color: "#000000" }}
                                                  dangerouslySetInnerHTML={createMarkup(
                                                    ele.jobdesc ? ele.jobdesc : "<p>NA</p>"
                                                  )}
                                                />
                                              </ST1>
                                            </Box>

                                            {/* <Typography
                                              variant="body2"
                                              sx={{ color: "#000000" }}
                                              dangerouslySetInnerHTML={createMarkup(
                                                ele.jobdesc ? ele.jobdesc : "<p>NA</p>"
                                              )}
                                            /> */}
                                          </Box>
                                        </Box>
                                      )}
                                    </Box>
                                    {viewIndex === "" ? (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex(id)}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          More details <img src={v1} alt="" />
                                        </Typography>
                                      </Box>
                                    ) : viewIndex === id ? (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex("")}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          Hide details <img src={v2} alt="" />
                                        </Typography>
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "24px",
                                          background: "#C6C6C6",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          onClick={() => setViewIndex(id)}
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            fontFamily: "Poppins",
                                            color: "#3B5092",
                                            "&:hover": {
                                              cursor: "pointer",
                                            },
                                          }}
                                        >
                                          More details <img src={v1} alt="" />
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </MuiGrid>
                              ))}
                            </MuiGrid>
                          </Box>
                        </>
                      ) : (
                        <>
                          <SoftBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            mt="50px"
                          >
                            <img src={noDataImg} width="100px" height="100px" />
                            <ST1 sx={{ mt: 1 }}>No active job requests</ST1>
                          </SoftBox>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        mt="50px"
                      >
                        <FadeLoader
                          color="#3B5092"
                          height={12}
                          width={5}
                          radius={2}
                          // margin={2}
                          cssOverride={override}
                        />
                      </SoftBox>
                    </>
                  )}
                </>
              ) : null}

              {/*
              {tableshow === 2 && step1 ?
                <>
                  {reqList.length === 0 ? (
                    <>
                      <SoftBox display="flex" flexDirection="column">
                        <ST3 variant="body1" p={2}>
                          Previous Requests
                        </ST3>
                      </SoftBox>

                      {!isLoading ? (
                        <>
                          {uploadedList.length !== 0 ? (
                            <>
                              <Box>
                                <MuiGrid container spacing={3} sx={{ p: 2 }}>
                                  {uploadedList?.filter((ele) => ele.is_active)?.map((ele, id) => (
                                    <MuiGrid item xs={12} key={id}>
                                      <Box
                                        sx={{
                                          width: "100%",
                                          background: "#FFFFFF",
                                          border: "1px solid #C6C6C6",
                                          borderRadius: "8px",
                                          boxShadow: 1,
                                        }}
                                      >
                                        <MuiGrid container>
                                          <MuiGrid item lg={5} md={6} sm={12} xs={12}>
                                            <Box sx={{ p: 2 }}>
                                              <ST1 variant="body2" sx={{ p: 0.25 }}>
                                                <span style={{ color: "#6C6C6C" }}>Organization:</span>{" "}
                                                {ele.org_name}
                                              </ST1>

                                              <ST1 variant="body2" sx={{ p: 0.25 }}>
                                                <span style={{ color: "#6C6C6C" }}>Job Profile:</span>{" "}
                                                {ele.job_title}
                                              </ST1>

                                              <ST1 variant="body2" sx={{ p: 0.25 }}>
                                                {moment(ele.createddt).format("LLLL")}
                                              </ST1>
                                            </Box>
                                          </MuiGrid>

                                          <MuiGrid item lg={3} md={6} sm={12} xs={12}>
                                            <Box
                                              sx={{
                                                p: 2,
                                                display: "flex",
                                                alignItems: "center",
                                                height: "100%",
                                              }}
                                            >
                                              <Box sx={{ p: 1 }}>
                                                <ST1 variant="body2">
                                                  <span style={{ color: "#6C6C6C" }}>
                                                    Cost/Candidate:
                                                  </span>{" "}
                                                  ₹{" "}
                                                  {ele?.amount_per_candidate
                                                    ? parseInt(ele?.amount_per_candidate)
                                                    : ""}
                                                </ST1>
                                              </Box>
                                            </Box>
                                          </MuiGrid>

                                          <MuiGrid item lg={4} md={12} sm={12} xs={12}>
                                            <Box
                                              sx={{
                                                p: 1,
                                                display: "flex",
                                                flexDirection: !matchsm ? "row" : "column",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                height: "100%",
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  width: !matchsm ? "none" : "100%",
                                                  marginRight: !matchsm ? "0px" : "10px",
                                                }}
                                              >
                                                <Button
                                                  sx={{
                                                    m: 1,
                                                    p: 2,
                                                    minWidth: !matchsm ? "50px" : "100%",
                                                    height: "34px",
                                                    background: "rgb(171, 233, 247)",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                      background: "rgb(171, 233, 247)",
                                                      cursor: "none",
                                                    },
                                                  }}
                                                >
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontSize: "14px",
                                                      fontWeight: 400,
                                                      lineHeight: "26px",
                                                      fontFamily: "Poppins",
                                                      color: "rgb(8, 161, 196)",
                                                    }}
                                                  >
                                                    ACTIVE
                                                  </Typography>
                                                </Button>
                                              </Box>

                                              <Box
                                                sx={{
                                                  width: !matchsm ? "none" : "100%",
                                                  marginRight: !matchsm ? "0px" : "10px",
                                                }}
                                              >
                                                <Button
                                                  onClick={() =>
                                                    navigate(
                                                      `/candidates?orgid=${ele.orgid}&jobid=${ele.jobid}`
                                                    )
                                                  }
                                                  sx={{
                                                    m: 1,
                                                    p: 2,
                                                    minWidth: !matchsm ? "80px" : "100%",
                                                    height: "34px",
                                                    background: "#B7F4BB",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                      background: "#B7F4BB",
                                                    },
                                                  }}
                                                >
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontSize: "14px",
                                                      fontWeight: 400,
                                                      lineHeight: "26px",
                                                      fontFamily: "Poppins",
                                                      color: "#049C2F",
                                                    }}
                                                  >
                                                    {`${ele.number_of_applicants} Candidates`}
                                                  </Typography>
                                                </Button>
                                              </Box>

                                              <Box
                                                sx={{
                                                  width: !matchsm ? "none" : "100%",
                                                  marginRight: !matchsm ? "0px" : "10px",
                                                }}
                                              >
                                                <Button
                                                  onClick={() => (
                                                    setUploadModal(true),
                                                    setObjectOfLinks(() => ({
                                                      ...objectOfLinks,
                                                      formLink: ele.form_link,
                                                      qrLink: ele.qr_code,
                                                      jobId: ele.jobid,
                                                      orgid: ele.orgid,
                                                    }))
                                                  )}
                                                  sx={{
                                                    m: 1,
                                                    p: 2,
                                                    minWidth: !matchsm ? "50px" : "100%",
                                                    height: "34px",
                                                    background: "#3B5092",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                      background: "#3B5092",
                                                    },
                                                  }}
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
                                                      stroke="white"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                    <path
                                                      d="M15 6L10 1L5 6"
                                                      stroke="white"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                    <path
                                                      d="M10 1V13"
                                                      stroke="white"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                </Button>
                                              </Box>
                                            </Box>
                                          </MuiGrid>
                                        </MuiGrid>
                                      </Box>
                                    </MuiGrid>
                                  ))}
                                </MuiGrid>
                              </Box>
                            </>
                          ) : (
                            <>
                              <SoftBox
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                mt="50px"
                              >
                                <img src={noDataImg} width="100px" height="100px" />
                                <ST1 variant="body2">No Data</ST1>
                              </SoftBox>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <SoftBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            mt="50px"
                          >
                            <FadeLoader
                              color="#3B5092"
                              height={12}
                              width={5}
                              radius={2}
                              // margin={2}
                              cssOverride={override}
                            />
                          </SoftBox>
                        </>
                      )}
                    </>
                  ) : null}
                </> :
                null
              }
              */}
            </SoftBox>
          )}

          {step2 && (
            <SoftBox display="flex" flexDirection="column" mb={1}>
              <ST3 variant="body1" p={2}>
                Archieved Requests
              </ST3>

              {!isLoading ? (
                <>
                  {uploadedList.length !== 0 ? (
                    <>
                      <Box>
                        <MuiGrid container spacing={3} sx={{ p: 2 }}>
                          {uploadedList
                            ?.filter((ele) => !ele.is_active)
                            ?.map((ele, id) => (
                              <MuiGrid item xs={12} key={id}>
                                <Box
                                  sx={{
                                    width: "100%",
                                    background: "#FFFFFF",
                                    border: "1px solid #C6C6C6",
                                    borderRadius: "8px",
                                    boxShadow: 1,
                                  }}
                                >
                                  <MuiGrid container>
                                    <MuiGrid item lg={5} md={6} sm={12} xs={12}>
                                      <Box sx={{ p: 2 }}>
                                        <ST1 variant="body2" sx={{ p: 0.25 }}>
                                          <span style={{ color: "#6C6C6C" }}>Organization:</span>{" "}
                                          {ele.org_name}
                                        </ST1>

                                        <ST1 variant="body2" sx={{ p: 0.25 }}>
                                          <span style={{ color: "#6C6C6C" }}>Job Profile:</span>{" "}
                                          {ele.job_name}
                                        </ST1>

                                        <ST1 variant="body2" sx={{ p: 0.25 }}>
                                          {moment(ele.createddt).format("LLLL")}
                                        </ST1>
                                      </Box>
                                    </MuiGrid>

                                    <MuiGrid item lg={3} md={6} sm={12} xs={12}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          display: "flex",
                                          alignItems: "center",
                                          height: "100%",
                                        }}
                                      >
                                        <Box sx={{ p: 1 }}>
                                          <ST1 variant="body2">
                                            <span style={{ color: "#6C6C6C" }}>
                                              Cost/Candidate:
                                            </span>{" "}
                                            ₹{" "}
                                            {ele?.amount_per_candidate
                                              ? parseInt(ele?.amount_per_candidate)
                                              : "0"}
                                          </ST1>
                                        </Box>
                                      </Box>
                                    </MuiGrid>

                                    <MuiGrid item lg={4} md={12} sm={12} xs={12}>
                                      <Box
                                        sx={{
                                          p: 1,
                                          display: "flex",
                                          flexDirection: !matchsm ? "row" : "column",
                                          alignItems: "center",
                                          justifyContent: "flex-end",
                                          height: "100%",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: !matchsm ? "none" : "100%",
                                            marginRight: !matchsm ? "0px" : "10px",
                                          }}
                                        >
                                          <Button
                                            sx={{
                                              m: 1,
                                              p: 2,
                                              minWidth: !matchsm ? "50px" : "100%",
                                              height: "34px",
                                              background: "#F5B7B1",
                                              textTransform: "none",
                                              "&:hover": {
                                                background: "#F5B7B1",
                                                cursor: "none",
                                              },
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "26px",
                                                fontFamily: "Poppins",
                                                color: "#CB4335",
                                              }}
                                            >
                                              INACTIVE
                                            </Typography>
                                          </Button>
                                        </Box>

                                        <Box
                                          sx={{
                                            width: !matchsm ? "none" : "100%",
                                            marginRight: !matchsm ? "0px" : "10px",
                                          }}
                                        >
                                          <Button
                                            onClick={() =>
                                              navigate(
                                                `/candidates?orgid=${ele.org_id}&jobid=${ele.jobpost_id}`
                                              )
                                            }
                                            sx={{
                                              m: 1,
                                              p: 2,
                                              minWidth: !matchsm ? "80px" : "100%",
                                              height: "34px",
                                              background: "#B7F4BB",
                                              textTransform: "none",
                                              "&:hover": {
                                                background: "#B7F4BB",
                                              },
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "26px",
                                                fontFamily: "Poppins",
                                                color: "#049C2F",
                                              }}
                                            >
                                              {`${ele.uploaded_candidates} Candidates`}
                                            </Typography>
                                          </Button>
                                        </Box>
                                      </Box>
                                    </MuiGrid>
                                  </MuiGrid>
                                </Box>
                              </MuiGrid>
                            ))}
                        </MuiGrid>
                      </Box>
                    </>
                  ) : (
                    <>
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        mt="50px"
                      >
                        <img src={noDataImg} width="100px" height="100px" />
                        <ST1 variant="body2">No Data</ST1>
                      </SoftBox>
                    </>
                  )}
                </>
              ) : (
                <>
                  <SoftBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    mt="50px"
                  >
                    <FadeLoader
                      color="#3B5092"
                      height={12}
                      width={5}
                      radius={2}
                      // margin={2}
                      cssOverride={override}
                    />
                  </SoftBox>
                </>
              )}
            </SoftBox>
          )}

          {step3 && (
            <SoftBox display="flex" flexDirection="column" mb={1}>
              <ST3 variant="body1" p={2}>
                Declined Requests
              </ST3>

              {!isLoading ? (
                <>
                  {declineList.length !== 0 ? (
                    <>
                      <Box>
                        <MuiGrid container spacing={3} sx={{ p: 2 }}>
                          {declineList?.map((ele, id) => (
                            <MuiGrid item xs={12} key={id}>
                              <Box
                                sx={{
                                  width: "100%",
                                  background: "#FFFFFF",
                                  border: "1px solid #C6C6C6",
                                  borderRadius: "8px",
                                  boxShadow: 1,
                                }}
                              >
                                <MuiGrid container>
                                  <MuiGrid item lg={4.5} md={6} sm={12} xs={12}>
                                    <Box sx={{ p: 2 }}>
                                      <ST1 variant="body2" sx={{ p: 0.25 }}>
                                        <span style={{ color: "#6C6C6C" }}>Organization:</span>{" "}
                                        {ele.org_name}
                                      </ST1>

                                      <ST1 variant="body2" sx={{ p: 0.25 }}>
                                        <span style={{ color: "#6C6C6C" }}>Job Profile:</span>{" "}
                                        {ele.job_title}
                                      </ST1>

                                      <ST1 variant="body2" sx={{ p: 0.25 }}>
                                        {moment(ele.createddt).format("LLLL")}
                                      </ST1>
                                    </Box>
                                  </MuiGrid>

                                  <MuiGrid item lg={3} md={6} sm={12} xs={12}>
                                    <Box
                                      sx={{
                                        p: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                      }}
                                    >
                                      <Box sx={{ p: 1 }}>
                                        <ST1 variant="body2">
                                          <span style={{ color: "#6C6C6C" }}>Cost/Candidate:</span>{" "}
                                          ₹{" "}
                                          {ele?.amount_per_candidate
                                            ? parseInt(ele?.amount_per_candidate)
                                            : ""}
                                        </ST1>
                                      </Box>
                                    </Box>
                                  </MuiGrid>

                                  <MuiGrid item lg={4.5} md={12} sm={12} xs={12}>
                                    <Box
                                      sx={{
                                        p: 1,
                                        display: "flex",
                                        flexDirection: !matchsm ? "row" : "column",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        height: "100%",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: !matchsm ? "none" : "100%",
                                          marginRight: !matchsm ? "0px" : "10px",
                                        }}
                                      >
                                        <Button
                                          sx={{
                                            m: 1,
                                            p: 2,
                                            minWidth: !matchsm ? "80px" : "100%",
                                            height: "34px",
                                            background: "#FFDEDE",
                                            textTransform: "none",
                                            "&:hover": {
                                              background: "#FFDEDE",
                                              cursor: "none",
                                            },
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontSize: "14px",
                                              fontWeight: 400,
                                              lineHeight: "26px",
                                              fontFamily: "Poppins",
                                              color: "#FF0000",
                                            }}
                                          >
                                            DECLINED
                                          </Typography>
                                        </Button>
                                      </Box>

                                      <Box
                                        sx={{
                                          width: !matchsm ? "none" : "100%",
                                          marginRight: !matchsm ? "0px" : "10px",
                                        }}
                                      >
                                        <Button
                                          sx={{
                                            m: 1,
                                            p: 2,
                                            minWidth: !matchsm ? "80px" : "100%",
                                            height: "34px",
                                            background: "#FFDEDE",
                                            textTransform: "none",
                                            "&:hover": {
                                              background: "#FFDEDE",
                                              cursor: "none",
                                            },
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontSize: "14px",
                                              fontWeight: 400,
                                              lineHeight: "26px",
                                              fontFamily: "Poppins",
                                              color: "#FF0000",
                                            }}
                                          >
                                            {ele.applicantct} Candidates
                                          </Typography>
                                        </Button>
                                      </Box>
                                    </Box>
                                  </MuiGrid>
                                </MuiGrid>
                              </Box>
                            </MuiGrid>
                          ))}
                        </MuiGrid>
                      </Box>
                    </>
                  ) : (
                    <>
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        mt="50px"
                      >
                        <img src={noDataImg} width="100px" height="100px" />
                        <SoftTypography fontSize="15px" fontWeight="small" mt={1}>
                          No Data
                        </SoftTypography>
                      </SoftBox>
                    </>
                  )}
                </>
              ) : (
                <>
                  <SoftBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    mt="50px"
                  >
                    <FadeLoader
                      color="#3B5092"
                      height={12}
                      width={5}
                      radius={2}
                      // margin={2}
                      cssOverride={override}
                    />
                  </SoftBox>
                </>
              )}
            </SoftBox>
          )}
        </SoftBox>
      </DashboardLayout>
      {/* modal for instructions */}
      <Modal
        show={instructionModal}
        onHide={() => {
          setInstructionModal(false);
          setUploadModal(true);
        }}
        size="xl"
        centered
      >
        <Modal.Body>
          <SoftBox width="100%" display="flex" justifyContent="flex-end" alignItems="center">
            <IconButton
              onClick={() => {
                setInstructionModal(false);
                setUploadModal(true);
              }}
            >
              {/* <CloseIcon size="small" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </SoftBox>

          <SoftBox
            sx={{
              border: "1px solid #6c6c6c",
              borderRadius: "10px",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <SoftTypography fontSize="20px" fontWeight="medium" marginTop="12px">
              Guidelines:
            </SoftTypography>
            <SoftTypography fontSize="16px">
              While uploading the file (only excel files accepted), you have to make sure that the
              following fields with exact headers are present. The system will accept files only if
              the following headers are present. Even if there is no data in any of the headers, the
              data will still be accepted (try to put as much data as possible). Any data without
              mobile number (in 10 digits) will be rejected.
            </SoftTypography>
            <br />

            <SoftTypography fontStyle="12px" fontSize="16px">
              <ul>
                <li>First Name</li>
                <li>Date of Birth (DD-MM-YYYY)</li>
                <li>Mobile Number</li>
                <li>District</li>
                <li>State</li>
                <li>Highest Education</li>
              </ul>
            </SoftTypography>
            <br />
          </SoftBox>
          <SoftBox sx={{ marginTop: "10px" }}>
            <SoftTypography fontSize="16px" marginBottom="16px">
              The following section explains how all the data should be entered.
            </SoftTypography>
            <Table columns={colGuidelines} dataSource={GuideData} pagination={false} mb={2} />
          </SoftBox>
        </Modal.Body>
      </Modal>

      {/* modal for export */}
      <Modal
        show={uploadModal}
        onHide={() => {
          setUploadModal(false);
          setShowSnackbar(false);
          setUploadOption(false);
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              {/* <p className="HeaderCSV"></p> */}
              <p></p>
              <IconButton
                onClick={() => (
                  setUploadModal(false), setShowSnackbar(false), setUploadOption(false)
                )}
              >
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                // className="HeaderCSV"
                style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}
              >
                Bulk Upload
              </p>

              <p
                // className="HeaderCSV"
                style={{
                  fontSize: "14px",
                  fontWeight: "small",
                  lineHeight: "19px",
                  color: "#000",
                  marginBottom: "8px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Please download the template file and reupload it with candidate details.
              </p>
              <SoftBox
                onClick={() => {
                  setInstructionModal(true);
                  setUploadModal(false);
                  setShowSnackbar(false);
                }}
                style={{
                  fontSize: "12px",
                  fontWeight: "small",
                  // lineHeight: "19px",
                  color: "#3B5092",
                  textDecorationLine: "underline",
                  cursor: "pointer",
                }}
              >
                Read Guidelines
              </SoftBox>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <Link to="/Data-Upload-Template.xlsx" target="_blank" download>
                  <button className="download-btn">
                    <span className="download-btn-Text">Download Template</span>
                  </button>
                </Link>
                {/* <div> */}

                {uploadedOption ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <input
                      className="form-control"
                      type="file"
                      //accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                      // accept="image/png, image/jpeg"
                      // onChange={handleFileUpload}
                      onChange={(e) => {
                        // const file = e.target.files[0],
                        console.log("resumefile ", e.target.files[0]),
                          setCSVFile(e.target.files[0]);
                      }}
                    />
                    <button className="template-btn" onClick={() => bulkUploadfunc()}>
                      <span className="template-btn-Text">Upload Template</span>
                    </button>
                  </div>
                ) : (
                  <button className="template-btn" onClick={() => setUploadOption(true)}>
                    <span className="template-btn-Text">Upload Template</span>
                  </button>
                )}
                {/* <input
                    id="imgupload"
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    // accept="image/png, image/jpeg"
                    // onChange={handleFileUpload}
                    onChange={(e) => {
                      // const file = e.target.files[0],
                      console.log("resumefile ", e.target.files[0]), setCSVFile(e.target.files[0]);
                    }}
                  /> */}
                {/* </div> */}
              </Box>
              <p
                // className="HeaderCSV"
                style={{ fontSize: "14px", fontWeight: 500, color: "#000", marginTop: "12px" }}
              >
                or
              </p>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                // className="HeaderCSV"
                style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}
              >
                Single Upload
              </p>
              <p
                // className="HeaderCSV"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  // fontFamily: "Montserrat",
                  fontStyle: "normal",
                  lineHeight: "19px",
                  color: "#000",
                  marginLeft: !matchsm ? "0px" : "30px",
                }}
              >
                Share the QR code or link to the candidates to register
              </p>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !matchsm ? "row" : "column",
                  justifyContent: "space-between",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "94px",
                      height: "94px",
                      background: "lightgrey",
                      marginBottom: "5px",
                      marginLeft: !matchsm ? "10px" : "80px",
                    }}
                  >
                    <img
                      src={objectOfLinks.qrLink !== "" ? objectOfLinks.qrLink : noDataImg}
                      width="94px"
                      height="94px"
                    />
                  </div>
                  <Link to={objectOfLinks.qrLink} target="_blank" download>
                    <button
                      // className="copy-btn"
                      // onClick={() => (
                      //   copy(objectOfLinks.qrLink),
                      //   setCopiedLink(objectOfLinks.qrLink),
                      //   toggleSnackbar()
                      // )}
                      style={{
                        marginLeft: !matchsm ? "0px" : "50px",
                        display: "inline-flex",
                        padding: " 5px 10px",
                        alignItems: "flex-start",
                        gap: "10px",
                        borderRadius: "2px",
                        background: "#d9d9d9",
                        height: "28px",
                      }}
                    >
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                      >
                        <path
                          d="M14.5 6.25H7.75C6.92157 6.25 6.25 6.92157 6.25 7.75V14.5C6.25 15.3284 6.92157 16 7.75 16H14.5C15.3284 16 16 15.3284 16 14.5V7.75C16 6.92157 15.3284 6.25 14.5 6.25Z"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.25 10.75H2.5C2.10218 10.75 1.72064 10.592 1.43934 10.3107C1.15804 10.0294 1 9.64782 1 9.25V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H9.25C9.64782 1 10.0294 1.15804 10.3107 1.43934C10.592 1.72064 10.75 2.10218 10.75 2.5V3.25"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill="currentColor"
                          d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
                        />
                        <path
                          fill="currentColor"
                          d="M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"
                        />
                      </svg>
                      <span className="copy-btn-Text">Download QR</span>
                    </button>
                  </Link>
                </Box>
                {!matchsm ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="117"
                    viewBox="0 0 2 117"
                    fill="none"
                  >
                    <path d="M1 0V117" stroke="#3B5092" />
                  </svg>
                ) : (
                  <hr style={{ color: "#344767" }} />
                )}
                <Box sx={{ textAlign: "center" }}>
                  <div
                    style={{
                      // height: "94px",
                      // background: "lightgrey",
                      // padding: "5px 250px 5px 10px",
                      marginTop: "25px",
                      // marginLeft: "10px",
                    }}
                  >
                    {/* <img src={}/> */}

                    <input
                      type="text"
                      placeholder="Form Link"
                      value={objectOfLinks.formLink ? objectOfLinks.formLink : ""}
                      style={{
                        display: "flex",
                        // justifyContent: "center",
                        alignItems: "flex-start",
                        border: "1px solid #3B5092",
                        width: "250px",
                        gap: "10px",
                        padding: "5px 10px 5px 10px",
                        fontSize: "12px",
                      }}
                    />
                  </div>

                  <a
                    href={objectOfLinks.formLink ? objectOfLinks.formLink : ""}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="copy-btn">
                      <span className="copy-btn-Text">Redirect to Form Link</span>
                    </button>
                  </a>

                  {/*
                  <button
                    className="copy-btn"
                    style={{
                      // display: "inline-flex",
                      // justifyContent: "center",
                      width: "185px",
                      marginLeft: "40px",
                    }}
                    onClick={() => (
                      copy(objectOfLinks.formLink),
                      setCopiedLink(objectOfLinks.formLink),
                      toggleSnackbar()
                    )}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <path
                        d="M14.5 6.25H7.75C6.92157 6.25 6.25 6.92157 6.25 7.75V14.5C6.25 15.3284 6.92157 16 7.75 16H14.5C15.3284 16 16 15.3284 16 14.5V7.75C16 6.92157 15.3284 6.25 14.5 6.25Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.25 10.75H2.5C2.10218 10.75 1.72064 10.592 1.43934 10.3107C1.15804 10.0294 1 9.64782 1 9.25V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H9.25C9.64782 1 10.0294 1.15804 10.3107 1.43934C10.592 1.72064 10.75 2.10218 10.75 2.5V3.25"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="copy-btn-Text">Copy Form Link</span>
                  </button>
                 */}
                </Box>
              </Box>
              <p
                // className="HeaderCSV"
                style={{
                  fontSize: "13px",
                  fontWeight: 400,
                  // fontFamily: "Montserrat",
                  fontStyle: "italic",
                  lineHeight: "19px",
                  color: "#DA0000",
                  marginTop: "29px",
                  marginBottom: "0px",
                }}
              >
                *Additional parameter for data source can be added under UTM data source.
              </p>
            </Box>
          </SoftBox>
          <SoftSnackbar
            color="success"
            icon="check"
            title="Link copied successfully"
            content={copiedLink}
            // dateTime="11 mins ago"
            open={showSnackbar}
            autoHideDuration={4000}
            close={toggleSnackbar}
          />
          {/* <Snackbar open={showSnackbar} autoHideDuration={4000} onClose={toggleSnackbar}>
            <Alert onClose={toggleSnackbar} severity="success" sx={{ width: "100%" }}>
              <p>Link copied successfully!</p>
              <p>{copiedLink}</p>
            </Alert>
          </Snackbar> */}
        </Modal.Body>
      </Modal>
      {/* modal for export */}

      {/* modal for uploading */}
      <Modal
        show={uploadingModal}
        onHide={() => {
          setUploadingModal(false);
        }}
        centered
        size="sm"
        closeButton
        contentClassName="modal-height"
      >
        <Modal.Body>
          <SoftBox display="flex" justifyContent="center" alignItems="center">
            <SoftBox display="flex" flexDirection="column" gap={3}>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                Uploading.....
              </SoftTypography>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 400 }}>
                Please wait as we are uploading the file
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for uploading */}
    </>
  );
};

export default JobRequestPage;
